import type { ChatMessage } from '../../lib/types';
import styles from './Chat.module.css';

interface Props {
  message: ChatMessage;
  onSpeak: () => void;
}

export function ChatMessageBubble({ message, onSpeak }: Props) {
  const isUser = message.role === 'user';
  const role = isUser ? 'Вы' : message.role === 'tool' ? 'Инструмент' : 'Сеть';
  const when = formatWhen(message.created_at);

  return (
    <li className={`${styles.turn} ${isUser ? styles.user : styles.ai}`}>
      <div className={`${styles.turnLabel} ${isUser ? styles.userLabel : styles.aiLabel}`}>
        <span>{role}</span>
        <span className={styles.when}>{when}</span>
      </div>

      {isUser ? (
        <p className={styles.userText}>{message.content || '…'}</p>
      ) : (
        <div className={styles.aiBody}>
          {splitParagraphs(message.content).map((para, i) => (
            <p key={i} className={styles.aiText}>
              {para}
              {i === splitParagraphs(message.content).length - 1 && message.pending && (
                <span className={styles.cursor} aria-hidden />
              )}
            </p>
          ))}
          {!message.pending && message.content && (
            <button
              className={styles.speakBtn}
              onClick={onSpeak}
              aria-label="Озвучить"
              type="button"
            >
              ♪ озвучить
            </button>
          )}
        </div>
      )}
    </li>
  );
}

function splitParagraphs(s: string): string[] {
  if (!s) return [''];
  return s.split(/\n{2,}/g).map((p) => p.trim());
}

function formatWhen(iso: string): string {
  try {
    const d = new Date(iso);
    return d.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' });
  } catch {
    return '';
  }
}
